export const GET_ENTRY_BANNER = "GET_ENTRY_BANNER";

export const CLOSE_DIALOGUE_ENTRY_BANNER = "CLOSE_DIALOGUE_ENTRY_BANNER";

export const CERATE_ENTRY_BANNER = "CERATE_ENTRY_BANNER";

export const UPDATE_ENTRY_BANNER = "UPDATE_ENTRY_BANNER";

export const DELETE_ENTRY_BANNER = "DELETE_ENTRY_BANNER";

export const OPEN_DIALOGUE_ENTRY_BANNER = "OPEN_DIALOGUE_ENTRY_BANNER";
